import { useTranslation } from '@thoughtspot/i18n';
import { Accordion, AccordionVariant, } from '@thoughtspot/radiant-react/widgets/accordion';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Tab, TabHeaderHorizontalAlignment, TabTrayLayout, TabTraySize, } from '@thoughtspot/radiant-react/widgets/tab';
import { VisualPropComponentTranslationKeys, } from '@thoughtspot/ts-chart-sdk';
import cx from 'classnames';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
import { sdkToTSTranslationKeyMap } from '../../utils/form-builder.util';
import { MemoizedPropElementComponent } from './form-builder.component';
export const WrapWithAlignment = ({ alignment, children, }) => {
    if (alignment === 'row') {
        return (React.createElement(Horizontal, { className: styles.horizontalSection }, children));
    }
    return React.createElement(Vertical, { className: styles.verticalSection }, children);
};
export const WrapWithLayout = ({ elementKey, propElement, layoutType, children, }) => {
    const { t } = useTranslation();
    const getTranslatedLabel = (propElement) => {
        let propElementLabelWithTranslation = '';
        if (propElement.type !== 'customsort') {
            propElementLabelWithTranslation = propElement.label;
            if (Object.values(VisualPropComponentTranslationKeys).includes(propElement?.labelTranslation)) {
                propElementLabelWithTranslation = t(sdkToTSTranslationKeyMap[propElement?.labelTranslation]);
            }
            else if (typeof propElement?.labelTranslation === 'string') {
                propElementLabelWithTranslation = t(propElement?.labelTranslation);
            }
        }
        return propElementLabelWithTranslation;
    };
    if (layoutType === 'accordion') {
        return (React.createElement(Accordion, { key: elementKey, noPadding: true, useContainedHeight: true, "data-testid": "accordion-element", variant: AccordionVariant.MULTI_LEVEL, expandMultipleItems: true, firstItemExpanded: propElement.isAccordianExpanded ?? false },
            React.createElement(Accordion.Item, { noPadding: true, key: `${elementKey}.${propElement.key}`, header: getTranslatedLabel(propElement), disabled: propElement.disabled ?? false, alignToHeader: false, "data-testid": `test-id-${elementKey}.${propElement.key}` },
                React.createElement(Vertical, { className: styles.accordionItem }, children))));
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: cx(styles.sectionHeader, {
                [styles.sectionHeaderDisabled]: propElement.disabled ?? false,
            }) }, getTranslatedLabel(propElement)),
        React.createElement(WrapWithAlignment, { alignment: propElement.alignment }, children)));
};
export const WrapWithOrWithoutTabs = ({ propElements, isTabLayout, onChange, visualProps, nativeConfigItemsForCustomChart, }) => {
    const { t } = useTranslation();
    const getTranslatedLabel = (propElement) => {
        let propElementLabelWithTranslation = '';
        if (propElement.type !== 'customsort') {
            propElementLabelWithTranslation = propElement.label;
            if (Object.values(VisualPropComponentTranslationKeys).includes(propElement?.labelTranslation)) {
                propElementLabelWithTranslation = t(sdkToTSTranslationKeyMap[propElement?.labelTranslation]);
            }
            else if (typeof propElement?.labelTranslation === 'string') {
                propElementLabelWithTranslation = t(propElement?.labelTranslation);
            }
        }
        return propElementLabelWithTranslation;
    };
    if (isTabLayout) {
        return (React.createElement(Tab, { layout: propElements[0].alignment === 'row'
                ? TabTrayLayout.Vertical
                : TabTrayLayout.Horizontal, size: TabTraySize.Small, selectedTabId: propElements[0].key, key: `${propElements[0].key}`, headerAlignment: TabHeaderHorizontalAlignment.CENTER }, propElements.map(tabElement => (React.createElement(Tab.Item, { key: `${tabElement.key}`, id: `${tabElement.key}`, name: getTranslatedLabel(tabElement), tooltipText: getTranslatedLabel(tabElement), tabBottomBorder: true, disabled: tabElement.disabled ?? false, "data-testid": `test-id-${tabElement.key}` },
            React.createElement(Vertical, { className: styles.tabItem }, tabElement.children.map(elem => {
                return (React.createElement(MemoizedPropElementComponent, { propElement: elem, visualProps: visualProps, elementKey: `${tabElement.key}.${elem.key}`, key: `${tabElement.key}.${elem.key}`, onChange: onChange, nativeConfigItemsForCustomChart: nativeConfigItemsForCustomChart }));
            })))))));
    }
    return (React.createElement(React.Fragment, null, propElements.map(elem => {
        return (React.createElement(MemoizedPropElementComponent, { propElement: elem, visualProps: visualProps, elementKey: elem.key, key: elem.key, onChange: onChange, nativeConfigItemsForCustomChart: nativeConfigItemsForCustomChart }));
    })));
};
//# sourceMappingURL=section-form.component.js.map